import {
  Box,
  Button,
  Grid,
  IconButton,
  Modal,
  Stack,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { StyledCreateTrainingPopup } from '../../styles/TrainingsStyle/TrainingsStyle';
import { ReactComponent as BorderX } from '../../assets/images/main-page/border-x-icon.svg';
import { StyledTextArea, StyledTextField } from '../../styles/FieldsStyles';
import { StyledEmployeesWrapper } from '../../styles/WorkArrangement/CreateArrangementStyle';
import { ReactComponent as Trash } from '../../assets/images/main-page/trash-icon.svg';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery } from 'react-query';
import { createClient, fetchClient, updateClient } from '../../api/clientApi';
import ErrorText from '../../components/validation/ErrorText';

function CreateClient({
  showCreateModal,
  setShowCreateModal,
  selectedUuid,
  setSelectedUuid,
  reloadData = () => {},
}) {
  const { t } = useTranslation('client');
  const [errors, setErrors] = useState({});
  const [newClient, setNewClient] = useState({
    phone: '',
    name: '',
    hp: '',
    adress: '',
    contacts: [
      {
        name: '',
        email: '',
        tell: '',
        officePhone: '',
        role: '',
        note: '',
      },
    ],
  });

  const resetData = () => {
    setNewClient({
      phone: '',
      name: '',
      hp: '',
      adress: '',
      contacts: [
        {
          name: '',
          email: '',
          tell: '',
          officePhone: '',
          role: '',
          note: '',
        },
      ],
    });
    setSelectedUuid(null);
    setShowCreateModal(false);
  };

  const handleAddContact = () => {
    const temp = [...newClient.contacts];
    temp.push({
      name: '',
      email: '',
      tell: '',
      officePhone: '',
      role: '',
      note: '',
    });

    setNewClient({ ...newClient, contacts: temp });
  };

  const handleChangeContact = (index, id, value) => {
    const temp = [...newClient.contacts];
    temp[index][id] = value;
    if (temp[index]?.uuid === '') {
      delete temp[index].uuid;
    }
    setNewClient({ ...newClient, contacts: temp });
  };

  // const handleDeleteContact = (index) => {
  //   let temp = [...newClient.contacts];
  //   temp = temp.filter((contact, i) => i !== index);
  //   setNewClient({ ...newClient, contacts: temp });
  // };

  const handleDeleteContact = (index) => {
    const temp = newClient.contacts.filter((_, i) => i !== index);
    setNewClient({ ...newClient, contacts: temp });
  };

  const createClientMutation = useMutation({
    mutationFn: createClient,
    onSuccess: (response) => {
      reloadData();
      setNewClient({
        phone: '',
        name: '',
        hp: '',
        adress: '',
        contacts: [
          {
            name: '',
            email: '',
            tell: '',
            officePhone: '',
            role: '',
            note: '',
          },
        ],
      });
      setSelectedUuid(null);
      setShowCreateModal(false);
    },
    onError: ({ response }) => {
      console.log('response', response);
    },
  });

  const updateClientMutation = useMutation({
    mutationFn: ({ uuid, body }) => updateClient(uuid, body),
    onSuccess: (response) => {
      reloadData();
      console.log('response', response);
      setNewClient({
        phone: '',
        name: '',
        hp: '',
        adress: '',
        contacts: [
          {
            name: '',
            email: '',
            tell: '',
            officePhone: '',
            role: '',
            note: '',
          },
        ],
      });
      setSelectedUuid(null);
      setShowCreateModal(false);
    },
    onError: ({ response }) => {
      console.log('response', response);
    },
  });

  const { data: client } = useQuery(
    ['client'],
    () => fetchClient(selectedUuid),
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      enabled: !!selectedUuid,
      onError: (err) => {
        console.log(err);
      },
    },
  );

  useEffect(() => {
    if (client?.data && selectedUuid) {
      setNewClient({
        phone: client.data.phone,
        name: client.data.name,
        hp: client.data.hp,
        adress: client.data.adress,
        contacts: client.data.Inspectors.map((inspector) => ({
          name: inspector.name,
          email: inspector.email,
          tell: inspector.tell,
          officePhone: inspector.officePhone,
          role: inspector.role,
          note: inspector.note,
          uuid: inspector.uuid,
        })),
      });
    }
  }, [client, selectedUuid]);

  const validateForm = () => {
    const errors = {};

    if (!newClient.name || !String(newClient.name).trim()) {
      errors.name = t('client.form.validation.name_required');
    }

    if (!newClient.hp || !String(newClient.hp).trim()) {
      errors.hp = t('client.form.validation.hp_required');
    }

    if (!newClient.phone || !String(newClient.phone).trim()) {
      errors.phone = t('client.form.validation.phone_required');
    } else {
      const phoneStr = String(newClient.phone).trim();
      const digitsOnly = phoneStr.replace(/-/g, '');
      const phonePattern = /^[\d-]+$/;
      if (!phonePattern.test(phoneStr)) {
        errors.phone = t('client.form.validation.contact_phone_numeric');
      } else if (digitsOnly.length < 10 || digitsOnly.length > 11) {
        errors.phone = t('client.form.validation.phone_length');
      }
    }

    if (!newClient.adress || !String(newClient.adress).trim()) {
      errors.adress = t('client.form.validation.address_required');
    }

    if (!newClient.contacts || newClient.contacts.length === 0) {
      errors.contacts = t(
        'client.form.validation.at_least_one_contact_required',
      );
    } else {
      const contactErrors = [];
      newClient.contacts.forEach((contact, i) => {
        const ce = {};
        if (!contact.name || !String(contact.name).trim()) {
          ce.name = t('client.form.validation.contact_name_required');
        }

        if (contact.email && String(contact.email).trim()) {
          const emailPattern = /\S+@\S+\.\S+/;
          if (!emailPattern.test(contact.email)) {
            ce.email = t('client.form.validation.contact_email_invalid');
          }
        }

        if (!contact.tell || !String(contact.tell).trim()) {
          ce.tell = t('client.form.validation.contact_phone_required');
        }
        if (contact.tell) {
          const tellStr = String(contact.tell).trim();
          const digitsOnly = tellStr.replace(/-/g, '');
          const tellPattern = /^[\d-]+$/;
          if (!tellPattern.test(tellStr)) {
            ce.tell = t('client.form.validation.contact_phone_numeric');
          } else if (digitsOnly.length < 10 || digitsOnly.length > 11) {
            ce.tell = t('client.form.validation.contact_phone_length');
          }
        }

        if (!contact.role || !String(contact.role).trim()) {
          ce.role = t('client.form.validation.contact_role');
        }

        contactErrors[i] = Object.keys(ce).length ? ce : null;
      });
      if (contactErrors.some((it) => it)) {
        errors.contacts = contactErrors;
      }
    }

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = () => {
    if (!validateForm()) return;

    if (selectedUuid) {
      updateClientMutation.mutate({
        uuid: selectedUuid,
        body: newClient,
      });
    } else {
      createClientMutation.mutate(newClient);
    }

    reloadData();
  };

  return (
    <Modal open={showCreateModal} onClose={resetData}>
      <StyledCreateTrainingPopup sx={{ overflow: 'scroll' }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          marginBottom="56px"
        >
          <Typography variant="h3">
            {selectedUuid
              ? t('client.form.edit_title')
              : t('client.form.add_title')}
          </Typography>
          <IconButton onClick={resetData}>
            <BorderX />
          </IconButton>
        </Stack>

        <Grid container gap="32px 24px" marginBottom="56px">
          <Grid item xs={5.8} sx={{ width: '100%' }}>
            <label
              htmlFor="client_name"
              style={{
                marginBottom: '8px',
                fontWeight: '500',
                display: 'block',
              }}
            >
              {t('client.clients_page.table_titles.client_name')}
            </label>
            <StyledTextField
              id="client_name"
              name="name"
              //   placeholder="0000000"
              value={newClient.name}
              onChange={(e) => {
                setNewClient({
                  ...newClient,
                  [e.target.name]: e.target.value,
                });
              }}
            />
            {errors.name && <ErrorText>{errors.name}</ErrorText>}
          </Grid>
          <Grid item xs={5.8} sx={{ width: '100%' }}>
            <label
              htmlFor="hp"
              style={{
                marginBottom: '8px',
                fontWeight: '500',
                display: 'block',
              }}
            >
              {t('client.clients_page.table_titles.h.p')}
            </label>
            <StyledTextField
              id="hp"
              name="hp"
              //   placeholder="0000000"
              value={newClient.hp}
              onChange={(e) => {
                const value = e.target.value
                  .replace(/\D/g, '') // remove non-digits
                  .slice(0, 9); // limit to 9 digits
                setNewClient({
                  ...newClient,
                  [e.target.id]: value,
                });
              }}
            />
            {errors.hp && <ErrorText>{errors.hp}</ErrorText>}
          </Grid>
          <Grid item xs={5.8} sx={{ width: '100%' }}>
            <label
              htmlFor="phone"
              style={{
                marginBottom: '8px',
                fontWeight: '500',
                display: 'block',
              }}
            >
              {t('client.clients_page.table_titles.office_tel')}
            </label>
            <StyledTextField
              id="phone"
              name="phone"
              //   placeholder="0000000"
              value={newClient.phone}
              onChange={(e) => {
                setNewClient({
                  ...newClient,
                  [e.target.id]: e.target.value,
                });
              }}
            />
            {errors.phone && <ErrorText>{errors.phone}</ErrorText>}
          </Grid>
          <Grid item xs={5.8} sx={{ width: '100%' }}>
            <label
              htmlFor="adress"
              style={{
                marginBottom: '8px',
                fontWeight: '500',
                display: 'block',
              }}
            >
              {t('client.clients_page.table_titles.address')}
            </label>
            <StyledTextField
              id="adress"
              name="adress"
              //   placeholder="0000000"
              value={newClient.adress}
              onChange={(e) => {
                setNewClient({
                  ...newClient,
                  [e.target.id]: e.target.value,
                });
              }}
            />
            {errors.adress && <ErrorText>{errors.adress}</ErrorText>}
          </Grid>
        </Grid>

        <Typography variant="runningText" component="p" marginBottom="32px">
          {t('client.clients_page.table_titles.contacts')}
        </Typography>

        {newClient.contacts?.map((contact, index) => {
          return (
            <StyledEmployeesWrapper
              key={index}
              direction="row"
              alignItems="center"
              marginBottom="32px"
              columnGap="18px"
            >
              <Box sx={{ flex: 1, width: '100%' }}>
                <Stack
                  direction="row"
                  columnGap="18px"
                  marginBottom="16px"
                  sx={{ width: '100%' }}
                >
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <label
                      htmlFor="contact_name"
                      style={{
                        marginBottom: '8px',
                        fontWeight: '500',
                        display: 'block',
                      }}
                    >
                      {t('client.contacts.full_name')}
                    </label>
                    <StyledTextField
                      id="contact_name"
                      name="name"
                      //   placeholder="0000000"
                      value={contact.name}
                      onChange={(e) =>
                        handleChangeContact(
                          index,
                          e.target.name,
                          e.target.value,
                        )
                      }
                    />
                    {errors.contacts?.[index]?.name && (
                      <ErrorText>{errors.contacts[index].name}</ErrorText>
                    )}
                  </Box>
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <label
                      htmlFor="email"
                      style={{
                        marginBottom: '8px',
                        fontWeight: '500',
                        display: 'block',
                      }}
                    >
                      {t('client.contacts.email')}
                    </label>
                    <StyledTextField
                      id="email"
                      name="email"
                      // placeholder="0000000"
                      value={contact.email}
                      onChange={(e) =>
                        handleChangeContact(index, e.target.id, e.target.value)
                      }
                    />
                    {errors.contacts?.[index]?.email && (
                      <ErrorText>{errors.contacts[index].email}</ErrorText>
                    )}
                  </Box>
                </Stack>
                <Stack
                  direction="row"
                  columnGap="18px"
                  marginBottom="16px"
                  sx={{ width: '100%' }}
                >
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <label
                      htmlFor="contact_phone"
                      style={{
                        marginBottom: '8px',
                        fontWeight: '500',
                        display: 'block',
                      }}
                    >
                      {t('client.contacts.phone')}
                    </label>
                    <StyledTextField
                      id="contact_phone"
                      name="tell"
                      // placeholder="0000000"
                      value={contact.tell}
                      onChange={(e) =>
                        handleChangeContact(
                          index,
                          e.target.name,
                          e.target.value,
                        )
                      }
                    />
                    {errors.contacts?.[index]?.tell && (
                      <ErrorText>{errors.contacts[index].tell}</ErrorText>
                    )}
                  </Box>
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <label
                      htmlFor="office_phone"
                      style={{
                        marginBottom: '8px',
                        fontWeight: '500',
                        display: 'block',
                      }}
                    >
                      {t('client.contacts.office_phone')}
                    </label>
                    <StyledTextField
                      id="office_phone"
                      name="officePhone"
                      // placeholder="0000000"
                      value={contact.officePhone}
                      onChange={(e) =>
                        handleChangeContact(
                          index,
                          e.target.name,
                          e.target.value,
                        )
                      }
                    />
                    {errors.contacts?.[index]?.officePhone && (
                      <ErrorText>
                        {errors.contacts[index].officePhone}
                      </ErrorText>
                    )}
                  </Box>
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <label
                      htmlFor="role"
                      style={{
                        marginBottom: '8px',
                        fontWeight: '500',
                        display: 'block',
                      }}
                    >
                      {t('client.contacts.role')}
                    </label>
                    <StyledTextField
                      id="role"
                      name="role"
                      // placeholder="0000000"
                      value={contact.role}
                      onChange={(e) =>
                        handleChangeContact(index, e.target.id, e.target.value)
                      }
                    />
                    {errors.contacts?.[index]?.role && (
                      <ErrorText>{errors.contacts[index].role}</ErrorText>
                    )}
                  </Box>
                </Stack>
                <Box width="100%">
                  <label
                    htmlFor="note"
                    style={{
                      marginBottom: '8px',
                      fontWeight: '500',
                      display: 'block',
                    }}
                  >
                    {t('client.contacts.notes')}
                  </label>
                  <StyledTextArea
                    id="note"
                    name="note"
                    height="90px"
                    // placeholder="0000000"
                    value={contact.note}
                    onChange={(e) =>
                      handleChangeContact(index, e.target.id, e.target.value)
                    }
                  />
                </Box>
              </Box>

              <IconButton onClick={() => handleDeleteContact(index)}>
                <Trash />
              </IconButton>
            </StyledEmployeesWrapper>
          );
        })}

        {errors.contacts && typeof errors.contacts === 'string' && (
          <ErrorText>{errors.contacts}</ErrorText>
        )}

        <Button
          variant="borderBlue"
          sx={{ padding: '8px 24px', marginBottom: '60px' }}
          onClick={handleAddContact}
        >
          {t('client.contacts.add_contact_button')}
        </Button>

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="end"
          columnGap="12px"
          marginBottom="48px"
        >
          <Button
            variant="borderBlue"
            onClick={resetData}
            sx={{ padding: '7px 15.5px' }}
          >
            {t('client.form.cancel')}
          </Button>
          <Button
            variant="main"
            onClick={handleSubmit}
            sx={{ padding: '7px 15.5px' }}
          >
            {selectedUuid ? t('client.form.update') : t('client.form.submit')}
          </Button>
        </Stack>
      </StyledCreateTrainingPopup>
    </Modal>
  );
}

export default CreateClient;
